import { j as t } from "../../../node_modules/react/jsx-runtime.js";
import { memo as v } from "react";
import { clsx as b } from "../../../node_modules/clsx/dist/clsx.m.js";
import { Avatar as x } from "../../atoms/Avatars/Avatar.js";
import { Typography as z } from "../../atoms/Typography/Typography.js";
import c from "../../atoms/Tooltip/Tooltip.js";
import w from "../../atoms/Spacer/Spacer.js";
import p from "./AvatarGroup.module.scss.js";
const G = (a) => {
  const {
    size: i = "xxl",
    type: j = "default",
    showAddMore: h = !0,
    maxAvatars: s,
    avatars: o,
    tooltipBehavior: u = "tooltip",
    ...g
  } = a, d = b(p.avatarGroupContainer, p[i], p[j]), y = () => {
    const n = o == null ? void 0 : o.length;
    let m = 1e3, e = o == null ? void 0 : o.map((r, l) => (m -= 1, r.tooltip ? /* @__PURE__ */ t.jsx(
      c,
      {
        placement: "bottom",
        behavior: u,
        title: r.tooltip,
        trigger: /* @__PURE__ */ t.jsx("div", { style: { zIndex: m }, children: /* @__PURE__ */ t.jsx(
          x,
          {
            ...r,
            size: i
          }
        ) })
      },
      `${l}-tooltip`
    ) : /* @__PURE__ */ t.jsx(
      "div",
      {
        style: { zIndex: m },
        children: /* @__PURE__ */ t.jsx(
          x,
          {
            ...r,
            size: i
          }
        )
      },
      l
    )));
    if (s && s < n && (e = e == null ? void 0 : e.splice(0, s), h)) {
      const r = o == null ? void 0 : o.splice(s, n).filter((l) => !!l.tooltip);
      if (r.length > 0) {
        const l = /* @__PURE__ */ t.jsx(t.Fragment, { children: r == null ? void 0 : r.map((f, A) => /* @__PURE__ */ t.jsxs("div", { children: [
          /* @__PURE__ */ t.jsx(
            z,
            {
              text: f.tooltip,
              variant: "body-new/regular",
              textColor: "color/fg/inverse"
            }
          ),
          /* @__PURE__ */ t.jsx(w, { height: 4 })
        ] }, A)) });
        e == null || e.push(
          /* @__PURE__ */ t.jsx(
            c,
            {
              placement: "bottom",
              title: l,
              trigger: /* @__PURE__ */ t.jsx(
                "div",
                {
                  className: p.showAddMore,
                  style: { zIndex: 1e3 },
                  children: /* @__PURE__ */ t.jsx(
                    x,
                    {
                      type: "initials",
                      imageAlt: `${n - s}+`,
                      size: i
                    }
                  )
                }
              )
            }
          )
        );
      } else
        e == null || e.push(
          /* @__PURE__ */ t.jsx(
            "div",
            {
              className: p.showAddMore,
              style: { zIndex: 1e3 },
              children: /* @__PURE__ */ t.jsx(
                x,
                {
                  type: "initials",
                  imageAlt: `${n - s}+`,
                  size: i
                }
              )
            }
          )
        );
    }
    return e;
  };
  return /* @__PURE__ */ t.jsx(
    "div",
    {
      className: d,
      ...g,
      children: y()
    }
  );
}, F = v(G);
export {
  F as default
};
//# sourceMappingURL=AvatarGroup.js.map
